import type { CatalogTree } from '../types';

// Billing operations (admin panel screens §3.6).
export const billing = {
  title: 'Ödeme işlemleri',
  tabsLabel: 'Ödeme işlemleri sekmeleri',
  tabs: {
    'failed-payments': 'Başarısız ödemeler',
    refunds: 'İadeler',
    'invoice-errors': 'Fatura hataları',
  },
  openMerchant: 'İşletmeyi aç',
  failed: {
    table: 'Başarısız ödemeler',
    empty: 'Başarısız ödeme yok.',
    step: { retrying: 'Yeniden deneniyor', grace: 'Ek süre', suspended: 'Askıda' },
    filters: { step: 'Adım' },
    columns: {
      merchant: 'İşletme',
      status: 'Abonelik',
      step: 'Adım',
      attempt: 'Deneme',
      amount: 'Tutar',
      error: 'Hata kodu',
      firstFailed: 'İlk başarısızlık',
      next: 'Sonraki tarih',
      card: 'Kart son kullanma',
    },
    retry: 'Yeniden dene',
    retryTitle: 'Ödemeyi yeniden dene',
    retryText: 'Kayıtlı karttan {tutar} hemen çekilmeye çalışılır.',
    queued: 'Kuyruğa alındı',
  },
  refunds: {
    table: 'İadeler',
    empty: 'Henüz iade yok.',
    new: 'Yeni iade',
    columns: {
      merchant: 'İşletme',
      payment: 'Ödeme',
      refunded: 'İade tutarı',
      refundedAt: 'İade zamanı',
      reason: 'Gerekçe',
      ref: 'İade referansı',
      invoices: 'Faturalar',
    },
    kind: { checkout: 'İlk ödeme', renewal: 'Yenileme', retry: 'Yeniden deneme', manual: 'Elle' },
    cancelled: 'İptal: {id}',
    replacement: 'Yeni: {id}',
    fields: { merchant: 'İşletme', payment: 'Ödeme', amount: 'Tutar', reason: 'Gerekçe' },
    hint: 'Kısmi iadede kalan tutar için yeni fatura kesilir. Abonelik durumu değişmez.',
    submit: 'İade et',
    overMax: 'En fazla {tutar} iade edilebilir.',
    confirmTitle: 'İade et',
    confirmText: '{tutar} sağlayıcı üzerinden iade edilir ve {fatura} iptal edilir.',
    invoiceFallback: 'ödemenin faturası',
    done: 'İade yapıldı.',
    invoiceNotIssued: 'Bu ödemenin faturası henüz kesilmedi; fatura kesildikten sonra iade edin.',
  },
  invoiceErrors: {
    table: 'Fatura hataları',
    empty: 'Fatura hatası yok.',
    notice:
      "Hatalı alıcı bilgileri işletme sahibince Ayarlar → İşletme'den düzeltilir; düzeltme sonrası faturayı yeniden düzenleyin.",
    columns: {
      merchant: 'İşletme',
      invoice: 'Fatura',
      paymentAt: 'Ödeme tarihi',
      deadline: 'Son tarih',
      status: 'Durum',
      attempts: 'Deneme',
    },
    reissue: 'Yeniden düzenle',
  },
} as const satisfies CatalogTree;
